export default __webpack_public_path__ + "images/hero-publication.jpg";